// extracted by mini-css-extract-plugin
export var backdropBlur = "_jl-0";
export var contentCard = "_jl-5";
export var frame = "_jl-2";
export var image = "_jl-4";
export var imagePane = "_jl-3";
export var modal = "_jl-1";